import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type {
    BariPostEnrollmentReadLabelV1,
    BariPostEnrollmentReadSectionTitleV1,
} from '../v1/bariPostEnrollmentReadSectionsV1';
import type { BariPostEnrollmentReadDataV2 } from './bariPostEnrollmentDataV2';
import { operatieReadSection } from '../bariPostEnrollmentReadSections';

export type BariPostEnrollmentReadKeyV2 = keyof BariPostEnrollmentReadDataV2;

export type BariPostEnrollmentReadLabelV2 =
    | BariPostEnrollmentReadLabelV1
    | 'HDL-cholesterol'
    | 'LDL-cholesterol'
    | 'LDL/HDL ratio'
    | 'HbA1c'
    | 'Triglyceriden';

export type BariPostEnrollmentReadSectionTitleV2 = BariPostEnrollmentReadSectionTitleV1;

export const bariPostEnrollmentReadSectionsV2: TypedReadSchema<
    BariPostEnrollmentReadKeyV2,
    BariPostEnrollmentReadLabelV2,
    BariPostEnrollmentReadSectionTitleV2
>[] = [
    operatieReadSection,
    {
        items: [
            {
                key: 'datum_lab_geprikt',
                label: 'Datum lab geprikt',
                type: 'dateAsString',
            },
            {
                key: 'assets',
                label: 'Pre-operatieve labwaarden',
            },
            {
                append: 'mmol/mol',
                key: 'hba1c',
                label: 'HbA1c',
                type: 'number',
            },
            {
                append: 'mmol/l',
                key: 'LDL_cholesterol',
                label: 'LDL-cholesterol',
                type: 'number',
            },
            {
                append: 'mmol/l',
                key: 'HDL_cholesterol',
                label: 'HDL-cholesterol',
                type: 'number',
            },
            {
                append: 'mmol/l',
                key: 'triglyceriden',
                label: 'Triglyceriden',
                type: 'number',
            },
            {
                key: 'LDL_HDL_ratio',
                label: 'LDL/HDL ratio',
            },
            {
                key: 'bijzonderheden_labwaarden',
                label: 'Bijzonderheden labwaarden',
                type: 'boolean',
            },
            {
                key: 'bijzonderheden_labwaarden_omschrijving',
                label: 'Omschrijving bijzonderheden',
            },
        ],
        sectionTitle: 'Labwaarden',
    },
];
